import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-task-data-target',
  standalone: true,
  imports: [],
  templateUrl: './task-data-target.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskDataTargetComponent {}
